<template>
  <div>
    <vue-dropzone
      ref="myVueDropzone"
      id="dropzone"
      :options="this.option"
      @vdropzone-error="handleError"
      @vdropzone-success="handleSuccess"
      @vdropzone-file-added="handleFileAdded"
      @vdropzone-removed-file="handleRemovedFile"
    >
    </vue-dropzone>
    <div class="info m-t-sm">
      <b class="text-red">※ファイルのアップロードは「アップロード」ボタンを押すことで完了となります。</b>
      <br>
      <span>※アップロードボタンを押した後、アップロード完了するまでしばらくお待ちください</span>
    </div>
    <div class="text-right m-t">
      <button :disabled="disableUpdloadFile" type="button" class="btn btn-warning m-w-120" @click="updateFiles">アップロード</button>
      <button type="button" class="btn m-w-120" data-dismiss="modal" @click="closeModal()">閉じる</button>
    </div>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import store from '@/store'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  props: {
    option: {
      type: Object
    }
  },
  components: {
    vueDropzone: vue2Dropzone
  },
  data () {
    return {
      loader: null,
      disableUpdloadFile: true
    }
  },
  beforeDestroy () {
    this.$emit('close')
    this.$refs.myVueDropzone.removeAllFiles()
    $('.modal-backdrop').remove()
  },
  methods: {
    handleError (file, response, xhr) {
      store.commit('toggleModal', {
        show: true,
        message: '審査用画像のアップロードに失敗しました。'
      })
      self.loader && self.loader.hide()
      this.resetDisableUpdloadFile()
    },
    handleSuccess (file, response) {
      store.commit('toggleModal', {
        show: true,
        message: '審査用画像のアップロードに成功しました。'
      })
      this.$emit('handleSuccess')
      self.loader && self.loader.hide()
      this.closeModal()
    },
    handleFileAdded (file) {
      setTimeout(() => {
        let dzPreviewSelector = $('.dz-preview')
        let dzErrorSelector = $('.dz-error')
        if (dzPreviewSelector.length > 1) {
          dzErrorSelector.remove()
          let messageErrorSelector = $('.dz-error-message span')
          if (messageErrorSelector.length) {
            if (messageErrorSelector.text()) {
              this.disableUpdloadFile = true
            } else {
              this.disableUpdloadFile = false
            }
          } else {
            this.disableUpdloadFile = true
          }
          this.showUpload()
        } else {
          this.disableUpdloadFile = !file.accepted
          let dzDefaultSelector = $('.dz-default')
          dzDefaultSelector.hide()
        }
      }, 300)
    },
    showUpload () {
      setTimeout(() => {
        let dzPreviewSelector = $('.dz-preview')
        if (!dzPreviewSelector.length) {
          let dzDefaultSelector = $('.dz-default')
          dzDefaultSelector.show()
        }
      }, 200)
    },
    handleRemovedFile (file, error, xhr) {
      setTimeout(() => {
        let messageErrorSelector = $('.dz-error-message span')
        if (messageErrorSelector.length) {
          if (messageErrorSelector.text()) {
            this.disableUpdloadFile = true
          } else {
            this.disableUpdloadFile = false
          }
        } else {
          this.disableUpdloadFile = true
        }
        let dzPreviewSelector = $('.dz-preview')
        let dzDefaultSelector = $('.dz-default')
        if (!dzPreviewSelector.length) {
          dzDefaultSelector.show()
        }
      }, 300)
    },
    updateFiles () {
      if (this.$refs.myVueDropzone.getQueuedFiles().length) {
        self.loader = this.$loading.show()
        this.$refs.myVueDropzone.processQueue()

        let logParams = {
          name: eventCode.warehouse_amazon.multi_channel_service_tab.click_upload_button,
          properties: {}
        }
        EventService.postTrackLog(logParams)
      } else {
        this.closeModal()
      }
    },
    closeModal () {
      this.resetDisableUpdloadFile()
      this.$refs.myVueDropzone.removeAllFiles()
      this.$emit('close')
    },
    resetDisableUpdloadFile () {
      this.disableUpdloadFile = true
    }
  },
  mounted () {
    this.$refs.myVueDropzone.removeAllFiles()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EvidenceImageInput.vue